module.exports = __webpack_public_path__ + "img/patrulla_gnacional_down_selected.ce14988e.svg";